import { v4 as uuid } from "uuid";
import { OptionsToString, StringToOptions } from "../../libs/util/util_string";
import { new_ErrorAlert } from "../export_spwk/ExportManager";
import { EnableMode, HisRule, RequiredMode } from "./SpwkUtilV3";
import { UniOption } from "./UniOption";

export class UniInput {

  static END_POINT = "uni_input";

  //#region  --- Columns ---
  serno = 0;
  guid; //= uuid();

  option_guid = "";

  sort_no = 1000;

  i_his_rule: HisRule = HisRule.None;

  /** HIS TextBox 對照的 Key */
  i_his_code = "";

  /** 申報用 input 代碼 */
  i_gov_code = "";

  input_code = "";

  input_kind: "" | "Text" | "Select" | "Int" | "Number" | "DateTime" = "";

  width = "";

  /** 目前是給日期時間用的 "YYYY/MM/DD" */
  input_format = "";

  /** 
  暫定，"0.5"(預設)、"0.1" 為單位切換小數
  
  暫時這樣判斷，如果經常使用 再抽出來
  */
  get_step(): "0.5" | "0.1" {

    // input_format 本來是給 日期 格式用的
    // 小數時，如果輸入的不是 "0.1" 則使用預設的 以0.5為單位 (因為特作的小數預設為)

    if (this.input_format == null || this.input_format === "") {
      return "0.5";
    } else if (this.input_format === "0.1") {
      return "0.1";
    } else {
      throw new_ErrorAlert("46846133 目前只能是 ''、'0.5'、'0.1' ");
    }

  }


  input_enabled: EnableMode = EnableMode.皆可更改; //""為皆可修改 0為皆不可修改 2為只有內部可改

  input_required: RequiredMode = RequiredMode.必填;

  input_items = "";//﹋男﹋女

  //數字輸入框,加入規則欄位
  digit = "";

  min_value = "";

  max_value = "";

  /** textbox的行數 */
  rows = 0;

  /** input 上方標題小文字 */
  input_label: string = "";

  /** hint 提示文字 */
  place_holder: string = "";


  getInputItems(): string[] { return StringToOptions(this.input_items); }
  setInputItems(guid: string[]): void { this.input_items = OptionsToString(guid); }


  // /** 此選項的 rhf_name */
  // get_Option_RhfName(): string {
  //   return SpwkUtil.get_Option_RhfName(this.question_chapter ?? "?????", this.question_code ?? "?????", this.option_code);
  // }

  // /** 選項內內涵Input 的 rhf_name */
  // get_Input_RhfName(input_key: string): string {
  //   return SpwkUtil.get_Input_RhfName(this.question_chapter ?? "?????", this.question_code ?? "?????", this.option_code, input_key);
  //   // return chapter + "." + this.question_code + "●" + this.option_code + "●txt_" + input_key;
  // }

  constructor() {
    this.guid = uuid();
  }

  //#region --- View ---
  form_guid: string | null = null;

  question_guid: string | null = null;
  question_chapter: string | null = null;
  question_code: string | null = null;
  question_kind: string | null = null;

  option_code: string | null = null;
  //#endregion

  //#region --- 手動填入 ---
  OwnerOption?: UniOption;
  //#endregion

  IsEnable(is_admin: boolean, ori_value: string | undefined): boolean {

    let re = false;

    let input_enabled = this.input_enabled;

    if (input_enabled === EnableMode.皆可更改) {
      re = true;
    } else if (input_enabled === EnableMode.皆不可更改) {
      re = false;
    } else if (input_enabled === EnableMode.院方可改) {
      if (is_admin === true) {
        re = true;
      } else {
        re = false;
      }

    } else if (input_enabled === EnableMode.受檢者有數值時不可改) {

      if (ori_value == null || ori_value === "") {
        re = true;// 空白時總是可以改
      } else {
        if (is_admin === true) {// 否則只有院方能改
          re = true;
        } else {
          re = false;
        }
      }

    } else {
      throw new_ErrorAlert("425783 未知的 input enabled 狀態!!!");
    }

    return re;
  }


}

export enum UniInputKind {
  None = "",
  Text = "Text",
  Select = "Select",
  DateTime = "DateTime",
  Int = "Int",
  Number = "Number",
}
